import useRealTimeMeetingsEnabled from '../meetings/hooks/useRealTimeMeetingsEnabled';
import useScheduleMeetingsEnabled from '../meetings/hooks/useScheduleMeetingsEnabled';

const useVideoEnable = (eventUniqueName: string) => {
    const { isLoading: isLoadingRealTime, data: isRealTimeMeetingsEnabled } =
        useRealTimeMeetingsEnabled(eventUniqueName);
    const { isLoading: isLoadingMeetingsEnabled, data: isScheduleMeetingsEnabled } =
        useScheduleMeetingsEnabled(eventUniqueName);

    return {
        isLoading: isLoadingRealTime || isLoadingMeetingsEnabled,
        data: isRealTimeMeetingsEnabled || isScheduleMeetingsEnabled,
    };
};

export default useVideoEnable;
